<template>
  <div>
    <h2 style="text-align: center; margin: 0">
      {{ currentDate.year() }}年<span class="header-eto"
        >[{{ dateMan.westYear干支(currentDate) }}]
      </span>
      {{ currentDate.month() + 1 }}月<span class="header-eto"
        >[{{ dateMan.month干支(currentDate) }}]
      </span>
    </h2>
    <div id="buttons">
      <button @click="prevMonth">前の月</button>
      <button @click="nextMonth">次の月</button>
      <button @click="thisMonth">今月</button>
    </div>
    <div style="max-width: 900px; border: 5px solid gray">
      <div
        class="weekRow"
        style="
          display: flex;
          flex-direction: row;
          /* border-left: 5px solid gray; */
          text-align: center;
        "
      >
        <div
          class="dayofweek"
          v-for="(dayOfWeek, index) in weekNames"
          :key="index"
          :class="getWeekClass(index)"
        >
          {{ dayOfWeek }}
        </div>
      </div>
      <div class="weekRow" v-for="(week, index) in calendars" :key="index">
        <div
          class="dayClass"
          v-for="(day, index) in week"
          :key="index"
          :class="[day.dayType, getWeekClass(index, day.holiday), day.monthType]"
        >
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="day">{{ day.date }}</div>
            <img class="moon" :src="day.img" />
          </div>
          <div class="rokuyo-eto">
            <span class="rokuyo">{{ day.rokuyo }}</span>
            <span class="eto">{{ day.day干支 }}</span>
          </div>
          <div class="sekki">{{ day.sekki }}</div>
          <div class="holiday">{{day.holiday}}</div>
          <div class="lunar-calendar"><span class="lunar-date-title">旧暦：</span>{{ day.lunarDate }}</div>
        </div>
      </div>
    </div>
    <div id="memo">chromeでは、インストールするとアプリとしてオフラインでも使えます。iOSの場合はsafariで、「ホーム画面に追加」をするとアプリの様に使えます。</div>
  </div>
</template>
<script>
import moment from "moment";
import ShingetuList from "../assets/shingetu.json";
import SekkiList from "../assets/sekki.json";
import holidayList from "../assets/holiday-list.json";
import {
  LunarDate,
  LunarCalendarManager,
  DateManager,
} from "../modules/LunarCalendar";

export default {
  data() {
    return {
      currentDate: moment(),
      weekNames: ["日", "月", "火", "水", "木", "金", "土"],
      lunarCalendar: new LunarCalendarManager(ShingetuList, SekkiList),
      dateMan: new DateManager(),
    };
  },
  methods: {
    getStartDate() {
      let date = moment(this.currentDate);
      date.startOf("month");
      const youbiNum = date.day();
      return date.subtract(youbiNum, "days");
    },
    getEndDate() {
      let date = moment(this.currentDate);
      date.endOf("month");
      const youbiNum = date.day();
      return date.add(6 - youbiNum, "days");
    },
    getCalendar() {
      const today = moment();
      let curDate = this.getStartDate();
      const endDate = this.getEndDate();
      const weekNumber = Math.ceil(endDate.diff(curDate, "days") / 7);

      let calendars = [];
      for (let week = 0; week < weekNumber; week++) {
        let weekRow = [];
        for (let day = 0; day < 7; day++) {
          let isToday = curDate.isSame(today, "day");
          let dayType = isToday ? "today" : "otherday";
          let monthType = curDate.isSame(this.currentDate, "month")
            ? "thismonth"
            : "othermonth";

          let date = curDate.format("YYYY-M-DD");
          let sekki = this.lunarCalendar.sekkiList[date];
          //console.log(date)
          if (sekki == null) {
            sekki = "";
          }
          const lunardate = this.getLunarDate(curDate);
          let lunaDateStr = "";
          let moonImgUrl = "";
          if (lunardate !== null) {
            lunardate.eto = this.dateMan.day干支(curDate);
            //console.log(date);
            //console.log(lunardate);
            const leapMonth = lunardate.isLeapMonth ? "閏" : "";

            lunaDateStr = `${leapMonth}${lunardate.month}/${lunardate.date}`;
            moonImgUrl = `/img/moon/moon${lunardate.date - 1}.svg`;
          }
          let holiday = holidayList[curDate.format("YYYY-MM-DD")];
          if (holiday == null) {
            holiday = "";
          }
          console.log(holiday);

          weekRow.push({
            date: curDate.get("date"),
            dayType: dayType,
            monthType: monthType,
            sekki: sekki,
            lunarDate: lunaDateStr,
            img: moonImgUrl,
            day干支: lunardate == null ? "" : lunardate.eto,
            rokuyo: lunardate.rokuyo,
            holiday: holiday, 
          });
          curDate.add(1, "days");
        }
        calendars.push(weekRow);
      }
      return calendars;
    },
    nextMonth() {
      this.currentDate = moment(this.currentDate).add(1, "month");
    },
    prevMonth() {
      this.currentDate = moment(this.currentDate).subtract(1, "month");
    },
    thisMonth() {
      this.currentDate = moment();
    },
    getWeekClass(index, holiday = "") {
      if (holiday != "") {
        return "sunday"        
      }
      switch (index) {
        case 6:
          return "saturday";
        case 0:
          return "sunday";
        default:
          return "weekday";
      }
    },
    getLunarDate(date) {
      return this.lunarCalendar.lunarDate(date);
    },
  },
  // beforeCreate () {
  //   console.log(this.lunarCalendar.sekkiList);
  // },
  mounted() {
    console.log(this.getCalendar());
    console.log(DateManager.西暦十干表);
  },
  computed: {
    calendars() {
      return this.getCalendar();
    },
  },
};
</script>
<style>
div#buttons {
  display: flex;
  flex-direction: row;
  max-width: 900px;
}

div#buttons button {
  background-color: lightgray;
  border-radius: 4px;
  width: 80px;
}

div#buttons button:last-of-type {
  margin-left: auto;
}

span.header-eto {
  font-size: 14px;
}
div.sunday {
  color: red;
}
div.saturday {
  color: blue;
}
div.weekRow {
  display: flex;
  border-bottom: 3px solid gray;
}
div.weekRow:last-of-type {
  border-bottom: none;
}
div.dayClass {
  background-color: rgb(232, 232, 248);
  flex: 1;
  min-height: 70px;
  border-left: none;
  border-right: 3px solid gray;
  /* border-bottom: 3px solid gray; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
div.dayClass:last-of-type {
  border-right: none;
}
div.othermonth {
  background-color: lightgray;
  color: darkgray;
}
div.today {
  background-color: rgb(136, 231, 255);
  font-weight: 2;
}
div.dayofweek {
  background-color: rgb(232, 232, 248);
  flex: 1;
  border-right: 3px solid gray;
  text-align: center;
}
div.dayofweek:last-child {
  border-right: none;
}

div.rokuyo-eto {
  margin-left: auto;
  /* align-items: end; */
}

@media screen and (min-width:480px) {  
  div.day {
    padding-left: 3px;
    font-size: 18px;
  }
  span.rokuyo{
    padding-left: 3px;
    font-size: 14px;
  }
  span.eto {
    padding-left: 2px;
    font-size: 14px;
  }
  div.sekki {
    margin-left: auto;
    font-size: 14px;
    /* align-self: end; */
    /* min-height: 12px; */
  }
  span.lunar-date-title {
    font-size: 11px;
  }
  div.lunar-calendar {
    font-size: 13px;
    margin-top: auto;
  }
  img.moon {
    width: 16px;
    height: 16px;
    padding-right: 1px;
    padding-left: 1px;
  }
  div.holiday {
    font-size: 14px;
  }
}
@media screen and (max-width:480px) {  
  div.day {
    padding-left: 1px;
    font-size: 15px;
  }
  span.rokuyo{
    font-size: 11px;
  }
  span.eto {
    padding-left: 1px;
    font-size: 11px;
  }
  div.sekki {
    margin-left: auto;
    font-size: 11px;
    /* min-height: 12px; */
  }
  span.lunar-date-title {
    font-size: 8px;
  }
  div.lunar-calendar {
    font-size: 11px;
    margin-top: auto;
  }
  img.moon {
    width: 15px;
    height: 14px;
    padding-right: 1px;
  }
  div.holiday {
    font-size: 10px;
  }
}
div#memo {
  font-size: 9px;
}
</style>
